// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2MayV","itemTitle":"ClientEmergencyInfo_itemTitle__aBHNn","itemText":"ClientEmergencyInfo_itemText__1SQcH"};